import script from "./CarlDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CarlDetail.vue?vue&type=script&setup=true&lang=js"

import "./CarlDetail.vue?vue&type=style&index=0&id=64807d65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64807d65"]])

export default __exports__